import { VStack, HStack, Icon } from "@/shared/ui/primitives";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

export const PainPointsSection = () => {
	const { t } = useTranslation();

	const painPoints = [
		{ icon: "Robot" as const },
		{ icon: "Send" as const },
		{ icon: "Pause" as const },
		{ icon: "Setting" as const },
	];

	return (
		<VStack className="w-full gap-[28px] z-20">
			<VStack className="gap-[6px]">
				<h2 className="text-[1.5rem] md:text-[2.25rem] text-ct-strong font-semibold text-center">
					{t("home.painPoints.title")}
				</h2>
				<p className="text-lg text-ct-regular font-medium text-center">
					{t("home.painPoints.description")}
				</p>
			</VStack>

			<HStack className="w-full gap-[20px] justify-center flex-col md:flex-row">
				{painPoints.map((point, index) => (
					<motion.div
						key={index}
						className="w-full self-stretch items-start"
						initial={{ opacity: 0, y: 30 }}
						whileInView={{ opacity: 1, y: 0 }}
						viewport={{ once: true, margin: "-100px" }}
						transition={{ duration: 0.5, delay: index * 0.1 }}
					>
						<VStack className="h-full gap-[16px] p-[24px] rounded-[16px] bg-bg-regular">
							<Icon name={point.icon} width={48} height={48} className="text-pm-strong" />
							<VStack className="gap-[6px]">
								<span className="text-lg text-ct-strong font-semibold text-center">
									{t(`home.painPoints.point${index + 1}.title`)}
								</span>
								<span className="text-md text-ct-regular font-medium text-center break-keep">
									{t(`home.painPoints.point${index + 1}.description`)}
								</span>
							</VStack>
						</VStack>
					</motion.div>
				))}
			</HStack>
		</VStack>
	);
};
